import { Box, Grid, Typography, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts';

const truncate = (text, max = 28) => {
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}...` : text;
};

const formatSeconds = (seconds = 0) => {
  const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
  const secs = String(seconds % 60).padStart(2, '0');

  return `${hrs}h ${mins}m`;
};

const ApontamentosDeHoje = ({ data = [] }) => {
  const theme = useTheme();

  if (data?.length > 0) {
    const maxValue = Math.max(...data.map((item) => item?.tempo || 0), 0);

    const getStep = () => {
      const hours = maxValue / 3600;

      if (hours <= 5) return 3600;
      if (hours <= 20) return 7200;

      return 86400;
    };

    const step = getStep();

    const ticks = [];

    for (let i = 0; i <= maxValue + step; i += step) {
      ticks.push(i);
    }

    return (
      <Grid item xs={12} md={6}>
        <Box gap={2} height="100%" display="flex" flexDirection="column">
          <Typography variant="h5" fontWeight="bold">
            Apontamentos de Hoje
          </Typography>
          <Box mt="auto" width="100%">
            <BarChart
              layout="horizontal"
              height={Math.max(data.length * 50, 100)}
              margin={{ left: 220, top: 0, right: 20 }}
              series={[
                {
                  data: data.map((item) => item?.tempo || 0),
                  color: theme.palette.primary.main,
                  valueFormatter: (value) => formatSeconds(value),
                },
              ]}
              yAxis={[
                {
                  scaleType: 'band',
                  data: data.map((item) => truncate(item?.name)),
                  categoryGapRatio: 0.5,
                },
              ]}
              xAxis={[
                {
                  label: 'Tempo Total Apontado',
                  min: 0,
                  max: ticks[ticks.length - 1],
                  tickInterval: ticks,
                  valueFormatter: (value) => formatSeconds(value),
                },
              ]}
            />
          </Box>
        </Box>
      </Grid>
    );
  }

  return null;
};

export default ApontamentosDeHoje;
